import { isValidPrice } from '@domain-group/javascript-utils'

const state = {
  id: null,
  price: '',
  product_code: '',
  provider_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'price', validation: isValidPrice, invalidMessage: 'Invalid Price Format' },
  { key: 'provider_id' },
  { key: 'title' },
]

export default state
